import { render, staticRenderFns } from "./LeftNavigationMenuVersion.vue?vue&type=template&id=06a15193&"
import script from "./LeftNavigationMenuVersion.vue?vue&type=script&lang=js&"
export * from "./LeftNavigationMenuVersion.vue?vue&type=script&lang=js&"
import style0 from "./LeftNavigationMenuVersion.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports